export const LOADER_STATUS = 'boilderplate/Summary/LOADER_STATUS';
export const SET_IS_EDIT = 'boilderplate/Summary/SET_IS_EDIT';
export const SAVE_DATA = 'boilderplate/Summary/SAVE_DATA';
export const SAVE_REJECTED_DATA = 'boilderplate/Summary/SAVE_REJECTED_DATA';
export const PROFILE_INFO = 'boilderplate/Summary/PROFILE_INFO';
export const PROFILE_DATA = 'boilderplate/Summary/PROFILE_DATA';
export const SAVE_SAVED_DATA = 'boilderplate/Summary/SAVE_SAVED_DATA';
export const SAVE_TRACK_RETURN = 'boilderplate/Summary/SAVE_TRACK_RETURN';
export const SAVE_VALIDATION_DATA = 'boilderplate/Summary/SAVE_VALIDATION_DATA';
export const SAVE_PREVIEW_FETCH_DATA = 'boilderplate/Summary/SAVE_PREVIEW_FETCH_DATA';
export const SAVE_PREVIEW_COMPARATIVE_DATA = 'boilderplate/Summary/SAVE_PREVIEW_COMPARATIVE_DATA';
export const SAVE_HISTORY_DATA = 'boilderplate/Summary/SAVE_HISTORY_DATA';
export const SET_ENTITY_LIST = 'boilderplate/Summary/SET_ENTITY_LIST';
export const SET_IS_SAVE_TO_GSTIN_MODAL = 'boilderplate/Summary/SET_IS_SAVE_TO_GSTIN_MODAL';
export const SAVE_GSTIN_MODAL_LIST_DATA = 'boilderplate/Summary/SAVE_GSTIN_MODAL_LIST_DATA';
export const SET_TOTAL_PAGES = 'boilderplate/GSTR7/Summary/SET_TOTAL_PAGES';


